import React from 'react';
import { ComponentDivider,SelectDropdownStyles, CapsuleButtonWrapper } from '../styles';
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
import { Form, Row, Col} from 'antd';
import PropTypes from "prop-types";
import { addMutualFund } from "../../../actions";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import MutualFund from './MutualFund';
import { ContentContainerSpaceSmall} from "../../../styles";
import DropDownComponent from "../../CommonComponents/DropDownComponent/DropDown";
import {defaultStock} from "../../CommonComponents/Data";
import DonorDetails from "./DonorDetails";
import { recordError } from "../../../../../../../utils/commonUtil";
import { stockCertificateState } from "../../../selectors";

class StockCertificate extends React.Component {
    constructor(props) {
        super(props);
        this.generateCheckData = this.generateCheckData.bind(this);
        this.addAnotherStock = this.addAnotherStock.bind(this);
        this.removeStock = this.removeStock.bind(this);
    }

    addAnotherStock = () => {
        try {
            let currentData = this.props.stockCertificateDetails;
            if (currentData.length < 20)
            {
            let data = defaultStock[0];
            currentData.push(data);
            let loggedInAddress = this.props.loggedInAddress;
                data.Donors[0] = loggedInAddress;
            this.props.addMutualAccount(currentData);
            }
        } catch (error) {
          recordError(error);
        }
    }

    removeStock = (index) => {
        try {
            let currentData = this.props.stockCertificateDetails;
            currentData.splice(index,1);
            this.props.addMutualAccount(currentData);
        } catch (error) {
          recordError(error);
        }
    }

    generateCheckData = (stocks) => {
        let data = [];
        let count = stocks.length;
        data = stocks.map((stock, index) => {
            return(<>
                <Row>
                <Col lg={{span:8}} md={{span:8}}>
                        <SelectDropdownStyles>
                        <DropDownComponent assetHeld="stockCertificate" accountId={index} contributionType="stockCertificateList" label="Type of account in which assets are registered" traverse="corporateInformation" updateSelect="true" selected="stockSelected" giftLength={this.props.stockCertificateDetails.length -1}/>
                        </SelectDropdownStyles>
                    </Col>
                </Row>
                { (stock.type !== "Select Account Type") ?
                        <Row>
                        <DonorDetails assetHeld="stockCertificate" accountId={index} contributionType="stockCertificateList" type={stock.type} count={this.props.stockCertificateDetails.length -1}/>
                        </Row>
                        : null
                }
                 <Row>
                        <MutualFund assetHeld="stockCertificate" accountId={index} count={count} selected="stockSelected" contributionType="stockCertificateList"/>
                </Row>
                {(index !== 0) ?
                    <CapsuleButtonWrapper marginBottom="30px">
                    <CapsuleButton
                        data-test="stockCertificateCapsule1"
                        text= "Remove Registration"
                        id={"button"+index} 
                        onClick={e => this.removeStock(index)}
                    />
                    </CapsuleButtonWrapper>
                    : null
                }
                {((index) < (stocks.length-1)) ?
                    <ComponentDivider marginTop="0px" marginBottom="40px" mT="0px" mB="40px"/>
                    : null
                }
            </>)
        });
        return data;
    }

    render() {
        return (
            <ContentContainerSpaceSmall>
                <div className="fluid">
            <Form hideRequiredMark>
            <div className={this.props.isBlock !== 'none' ? 'block' : 'display-none' }>
                {this.generateCheckData(this.props.stockCertificateDetails)}         
                        <CapsuleButtonWrapper marginBottom="30px">
                        <CapsuleButton
                            data-test="stockCertificateCapsule0"
                            text= "Add another registration"
                            iconType="add"
                            padding="5px 20px"
                            disabled={this.props.stockCertificateDetails.length === 20 ? true : false}
                            onClick={e => this.addAnotherStock(e)}
                            id="btnAddAnotherReg"
                        />
                        </CapsuleButtonWrapper>
            </div>
                </Form>
                </div>
                </ContentContainerSpaceSmall>
        )
    }
}

const WrappedStockCertificate = Form.create({ name: "AssetHeldOutsideVanguard" })(StockCertificate);

WrappedStockCertificate.propTypes = {
    stockCertificateDetails: PropTypes.array,
    loggedInAddress: PropTypes.object,
    addMutualAccount: PropTypes.func,
}

const mapStateToProps = state => ({
    ...stockCertificateState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
    addMutualAccount: arr => dispatch(addMutualFund({value: arr, contributionType: "stockCertificateList", assetHeld:"stockCertificate", selected:'stockSelected'})),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedStockCertificate));